export const slider = [
  {
    id: 1,
    image:
      "https://promos.makemytrip.com/notification/xhdpi/Vande-Flight-10072020.png",
    content:
      "Vande Bharat helpline : Call 0124-4628747 for international flight booking!",
  },
  {
    id: 2,
    image:
      "https://promos.makemytrip.com/Growth/Images/B2C/2x/language1@2x_20210901.png",
    content: "We are now available in हिंदी",
  },
  {
    id: 3,
    image:
      "https://promos.makemytrip.com/Growth/Images/B2C/2x/ic_flight_covid_info_dt.png",
    content: "Flight booking impacted due to COVID-19?",
  },
  {
    id: 4,
    image:
      "https://promos.makemytrip.com/notification/xhdpi/Vande-Flight-10072020.png",
    content: "Booking an international flight?",
  },
  {
    id: 5,
    image:
      "https://promos.makemytrip.com/Growth/Images/B2C/2x/ic_flight_covid_info_dt.png",
    content:
      "Check international destinations open for Indians here, with their guidelines",
  },
];
